import { styled, keyframes } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

// MUI port of the Tailwind AuthLoader: a full-screen overlay with a primary
// ring spinning around a shield, plus pulsing "Please wait" text.
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

// fixed inset-0 + flex column center + dark card background + high z-index
const Overlay = styled(Box)(({ theme }) => ({
  position: "fixed",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
  // Theme-aware: white in light mode, dark in dark mode — follows the app theme.
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  zIndex: theme.zIndex.modal + 1,
}));

// relative wrapper that centers the ring over the shield
const IconWrap = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

// w-32 h-32 ring, top/bottom transparent, primary on left/right, spinning
const Ring = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: 128,
  height: 128,
  borderRadius: "50%",
  border: `4px solid ${theme.palette.primary.main}`,
  borderTopColor: "transparent",
  borderBottomColor: "transparent",
  animation: `${spin} 1s linear infinite`,
}));

// w-16 h-16 shield, primary, sits above the ring
const Shield = styled(ShieldOutlinedIcon)(({ theme }) => ({
  position: "relative",
  zIndex: 10,
  width: 64,
  height: 64,
  color: theme.palette.primary.main,
}));

const WaitText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3),
  fontSize: "1.125rem", // text-lg
  fontWeight: 500,
  color: theme.palette.text.secondary,
  animation: `${pulse} 2s ease-in-out infinite`,
}));

const AuthLoader = ({ isLoading = true }) => {
  if (!isLoading) return null;

  return (
    <Overlay>
      <IconWrap>
        <Ring />
        <Shield />
      </IconWrap>
      <WaitText>Please wait</WaitText>
    </Overlay>
  );
};

export default AuthLoader;
